import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { finishOptions } from 'constants/finishing';

const CoolingFin = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Cooling Fin</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.coolingFinQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.coolingFinNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.coolingFinFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>
    );
};

export default CoolingFin;
